// TODO: use blacklist approach in the future

const defaultPrivileges = {
    offers: {
        read: true,
        write: true,
        specified: {
            item: '',
            read: true,
            write: true,
        },
    },
    publishers: {
        read: true,
        write: true,
        specified: {
            item: '',
            read: true,
            write: true,
        },
    },
    advertisers: {
        read: true,
        write: true,
        specified: {
            item: '',
            read: true,
            write: true,
        },
    },
    smart_links: {
        read: true,
        write: true,
        specified: {
            item: '',
            read: true,
            write: true,
        },
    },
    triggers: {
        read: true,
        write: true,
        specified: {
            item: '',
            read: true,
            write: true,
        },
    },
    onboarding: {
        read: true,
        write: true,
        specified: {
            item: '',
            read: true,
            write: true,
        },
    },
    approvals: {
        read: true,
        write: true,
        specified: {
            item: '',
            read: true,
            write: true,
        },
    },
    users: {
        read: true,
        write: true,
        specified: {
            item: '',
            read: true,
            write: true,
        },
    },
    email_templates: {
        read: true,
        write: true,
        specified: {
            item: '',
            read: true,
            write: true,
        },
    },
    creatives: {
        read: true,
        write: true,
    },
    currency_management: {
        read: true,
        write: true,
    },
    external_integrations: {
        read: true,
        write: true,
    },
    imports: {
        read: true,
        write: true,
    },
    reports: {
        read: true,
        write: true,
    },
    settings: {
        read: true,
        write: true,
        fraud_protection: true,
    },
    traffic_filtering: {
        read: true,
        write: true,
    },
    query_filtering: {
        read: true,
        write: true,
    },
    applications: {
        read: true,
        write: true,
    },
    foreign_leads: {
        read: true,
        write: true,
    },
};

export {
    defaultPrivileges,
};
